import React, { useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/gqgeGFKyMhfT7rusiCXu5i/payne_equipment_logo.png';
const NAV_LINKS = [{
  label: 'Equipment',
  href: '#equipment'
}, {
  label: 'About',
  href: '#why-pes'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return <>
      <header className="sticky top-0 z-50 w-full bg-brand-dark/95 backdrop-blur-sm border-b border-brand-border overflow-visible" data-id="element-160">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
          <div className="flex items-center justify-between h-16 md:h-20" data-id="element-162">
            {/* Logo */}
            <a href="#" className="flex-shrink-0" aria-label="Payne Equipment Sales Home" data-id="element-163">
              <img src={LOGO_URL} alt="Payne Equipment Sales LLC" className="h-auto w-auto max-w-[200px] md:max-w-[300px]" data-id="element-164" />
            </a>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8" aria-label="Main navigation" data-id="element-165">
              {NAV_LINKS.map(link => <a key={link.label} href={link.href} className="font-oswald text-sm uppercase tracking-wider text-white/80 hover:text-brand-orange transition-colors duration-200" data-id="element-166">
                  {link.label}
                </a>)}
              <a href="tel:+16235551234" className="flex items-center gap-2 text-sm text-white/80 hover:text-white transition-colors" data-id="element-167">
                <PhoneIcon className="w-4 h-4" aria-hidden="true" data-id="element-168" />
                <span data-id="element-169">(623) 299-8071</span>
              </a>
              <a href="#contact" className="inline-flex items-center justify-center px-6 py-2.5 bg-brand-orange text-white font-oswald font-600 text-sm uppercase tracking-wider rounded-md hover:bg-brand-orange/90 transition-colors duration-200 min-h-[48px]" data-id="element-170">
                Get a Quote
              </a>
            </nav>

            {/* Mobile Hamburger */}
            <button type="button" className="md:hidden p-3 mr-0 text-white min-w-[48px] min-h-[48px] flex items-center justify-center" onClick={() => setMobileOpen(!mobileOpen)} aria-expanded={mobileOpen} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} data-id="element-171">
              {mobileOpen ? <XIcon className="w-6 h-6" data-id="element-172" /> : <MenuIcon className="w-6 h-6" data-id="element-173" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu — Full-screen overlay */}
      {mobileOpen && <>
          {/* Backdrop */}
          <div className="md:hidden fixed inset-0 z-[9998] bg-black/50" onClick={() => setMobileOpen(false)} aria-hidden="true" data-id="element-174" />
          {/* Menu panel */}
          <nav className="md:hidden fixed top-16 left-0 right-0 z-[9999] bg-brand-dark border-t border-brand-border shadow-2xl max-h-[calc(100vh-4rem)] overflow-y-auto" aria-label="Mobile navigation" data-id="element-175">
            <div className="px-4 py-4 space-y-1" data-id="element-176">
              {NAV_LINKS.map(link => <a key={link.label} href={link.href} onClick={() => setMobileOpen(false)} className="flex items-center px-4 py-3 font-oswald text-base uppercase tracking-wider text-white/80 hover:text-brand-orange hover:bg-brand-card rounded-md transition-colors min-h-[48px]" data-id="element-177">
                  {link.label}
                </a>)}
              <a href="tel:+16235551234" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-3 text-base text-white/80 hover:text-white min-h-[48px]" data-id="element-178">
                <PhoneIcon className="w-5 h-5" aria-hidden="true" data-id="element-179" />
                <span data-id="element-180">(623) 299-8071</span>
              </a>
              <a href="#contact" onClick={() => setMobileOpen(false)} className="block mx-4 mt-2 text-center px-6 py-3 bg-brand-orange text-white font-oswald font-semibold uppercase tracking-wider rounded-md min-h-[48px]" data-id="element-181">
                Get a Quote
              </a>
            </div>
          </nav>
        </>}
    </>;
}